jQuery(document).ready(() =>{
    jQuery('#toc-items a[href^="#"]').click(function(e) {
        e.preventDefault();

        var offset = 130;
        var target =  jQuery(e.currentTarget).attr('href');
        var $target = jQuery(target);

        jQuery('html, body').stop().animate({
            'scrollTop': $target.offset().top - offset
        }, 500);
    }); 
});